import React, { useState, forwardRef } from 'react';
import styled from 'styled-components';
import Input, { InputProps } from '@/common/view/form/Input';
import Icon from '@/common/view/icons';
import useIsCapsLockActive from '@/common/util/useIsCapsLockActive';

const CapslockIconBox = styled.div`
  position: absolute;
  top: 12px;
  right: 44px;
  display: block;
  width: 20px;
  height: 20px;
  svg {
    display: block;
  }
`;
const IconBox = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
// &[type='password'] {
//   font-family: Verdana;
//   font-size: 13px;
// }
const Box = styled.div`
  position: relative;
  input {
    width: 100%;
    padding-right: 44px;
  }

  ${IconBox} {
    position: absolute;
    top: 10px;
    right: 12px;
  }
`;

type PasswordInputProps = Omit<InputProps, 'type'>;
const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const isCapsLockActive = useIsCapsLockActive();
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Box>
      <Input {...props} ref={ref} type={showPassword ? 'text' : 'password'} />
      {isCapsLockActive && (
        <CapslockIconBox>
          <Icon.Capslock width={20} height={20} />
        </CapslockIconBox>
      )}

      <IconBox
        onClick={(e) => {
          e.stopPropagation();
          setShowPassword(!showPassword);
        }}>
        {showPassword ? (
          <Icon.EyeOn width={22} height={22} />
        ) : (
          <Icon.EyeOff width={22} height={22} />
        )}
      </IconBox>
    </Box>
  );
});

PasswordInput.displayName = 'PasswordInput';
export default PasswordInput;
